'use client'

import dynamic from 'next/dynamic'
import { CSSProperties, ReactNode } from 'react'

const UParallaxLogic = dynamic(() => import('@/components/Common/UParallax/UParallaxLogic'), {
  ssr: true,
})

type ChildrenProps = {
  plusHeight: number
}
interface UParallaxProps {
  distance?: number
  isFv?: boolean
  skipTopPropaty?: boolean
  addClass?: string
  addChildClass?: string
  children: ReactNode | ((_: ChildrenProps) => ReactNode)
  subChildren?: ReactNode
  style?: CSSProperties
}

export default function UParallax({
  distance = 0,
  isFv = false,
  skipTopPropaty = false,
  addClass = '',
  addChildClass = '',
  children,
  subChildren = <></>,
  style = {},
}: UParallaxProps) {
  return (
    <>
      <UParallaxLogic
        distance={distance}
        isFv={isFv}
        skipTopPropaty={skipTopPropaty}
        addClass={addClass}
        addChildClass={addChildClass}
        subChildren={subChildren}
        style={style}
      >
        {children}
      </UParallaxLogic>
    </>
  )
}
